// Sentry initialization must be imported first
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import '@/assets/scss/main.scss';

import App from './app/app.tsx';
import './sentry.ts';

const container = document.getElementById('root')!;
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error:', error, errorInfo);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(<App />);
